import {Component, input} from '@angular/core';

@Component({
  selector: 'app-phase-bar',
  templateUrl: './phase-bar.component.html',
})
export class PhaseBarComponent {
  readonly color = input.required<string>();
  readonly label = input.required<string>();
  readonly phaseLocked = input<boolean>(false);
}
